import {
  getAuthRefreshEvent,
  setAuthRefreshEvent,
  waitForAuthRefreshEvent,
} from './sessionStorage';

export const createAuthRefreshOwnerId = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `auth-refresh-${Date.now()}`;
};

export const waitForCoordinatedAuthRefresh = async (
  ownerId: string,
): Promise<'none' | 'succeeded' | 'failed' | 'timed_out'> => {
  return await waitForAuthRefreshEvent({ ownerId });
};

export const markAuthRefreshStarted = (ownerId: string): number => {
  const startedAt = Date.now();
  setAuthRefreshEvent({
    state: 'started',
    ownerId,
    at: startedAt,
  });
  return startedAt;
};

export const markAuthRefreshFinished = (ownerId: string, state: 'succeeded' | 'failed'): void => {
  setAuthRefreshEvent({
    state,
    ownerId,
    at: Date.now(),
  });
};

export const clearOwnedAuthRefreshEvent = (ownerId: string, startedAt: number): void => {
  const latestRefreshEvent = getAuthRefreshEvent();
  if (!latestRefreshEvent) return;
  if (latestRefreshEvent.ownerId !== ownerId) return;
  if (latestRefreshEvent.at < startedAt) {
    setAuthRefreshEvent(null);
  }
};
